import { useEffect, useRef } from "react";

const POLL_INTERVAL_MS = 60_000;
const SESSION_VERSION_KEY = "app_version";
const VERSION_PATH = "/version.json";

export const useVersionCheck = (isEnabled: boolean) => {
  const currentVersionRef = useRef<string | null>(null);
  const isReloadingRef = useRef(false);

  useEffect(() => {
    if (!isEnabled) return;
    if (typeof window === "undefined") return;
    if (!currentVersionRef.current) {
      currentVersionRef.current = sessionStorage.getItem(SESSION_VERSION_KEY);
    }
    const checkVersion = async () => {
      if (isReloadingRef.current) return;

      try {
        const versionUrl = `${window.location.origin}${VERSION_PATH}?t=${Date.now().toString()}`;
        const response = await fetch(
          versionUrl,
          {
            cache: "no-store",
          }
        );

        if (!response.ok) return;

        const payload = (await response.json()) as { version?: string };
        const nextVersion = payload.version?.trim();

        if (!nextVersion) return;

        if (!currentVersionRef.current) {
          currentVersionRef.current = nextVersion;
          sessionStorage.setItem(SESSION_VERSION_KEY, nextVersion);
          return;
        }

        if (currentVersionRef.current === nextVersion) return;

        currentVersionRef.current = nextVersion;
        sessionStorage.setItem(SESSION_VERSION_KEY, nextVersion);
        isReloadingRef.current = true;
        window.location.reload();
      } catch (error) {
        console.error("Version check failed:", error);
      }
    };

    void checkVersion();
    const intervalId = window.setInterval(() => {
      void checkVersion();
    }, POLL_INTERVAL_MS);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [isEnabled]);
};
